module.exports = __webpack_public_path__ + "assets/imgs/main-top-block-desktop-bg.v1.png";